import React, { useState, useRef } from "react";
import styled from "styled-components";
import image from "./assets/logo_primary_background_1.png";
import hide from "./assets/hide.png";

const Container = styled.div`
  background-color: #222222;
  background-repeat: no-repeat;
  background-size: cover;
  overflow-x: hidden;
  color: white;
  font-family: "Oxanium";
  min-height: 100vh;
  overflow-y: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  .example::-webkit-scrollbar {
    display: none;
  }
  font-family: "Oxanium-SemiBold";
  display: flex;
  flex-direction: column;
  img {
    padding-top: 100px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  h1 {
    color: white;
    margin-right: auto;
    margin-left: auto;
    width: 50%;
    text-align: center;
    font-size: 27px;
    font-weight: bolder;
  }
  div.outer {
    margin: auto;
    flex-direction: column;
    @media only screen and (min-width: 600px) {
      width: 50%;
    }
    justify-content: center;
    align-items: center;
    align-self: center;
    align-items: center;
  }
  .max {
    max-width: 300px;
    margin: 10px auto;
    p {
      text-align: center;
    }
  }
  .text-message {
    max-width: 300px;
    margin: 5px auto 0px;
    p {
      font-size: 10px;
    }
  }
  .text-label {
    max-width: 300px;
    margin: 0px auto 0px;
    p {
      font-size: 14px;
    }
  }
  p {
    color: white;
  }

  a {
    text-decoration: none;
    color: white;
  }
  button {
    background-color: #ffeb32;
    border-radius: 12px;
    outline: none;
    border-style: none;
    width: 100%;
    cursor: pointer;
    padding: 10px;
  }
`;

const StyledInput = styled.input`
  display: block;
  padding: 10px;
  background-color: #313131;
  border-style: none;
  margin-top: 5px;
  margin-bottom: 5px;
  border-radius: 12px;
  outline: none;
  width: 100%;
  color: white;
`;
const InputDiv = styled.div`
  background-color: #313131;
  margin-top: 0px;
  margin-bottom: 0px;
  border-radius: 12px;
  margin-left: auto;
  margin-right: auto;
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: space-between;
  label {
    margin-right: 15px;
    color: #838282;
    font-size: 14px;
    line-height: 17px;
  }
  max-width: 300px;
  div.image-label {
    display: flex;
    flex-direction: row;
    img {
      padding: 0;
      margin: 0;
      margin-right: 10px;
    }
  }
`;

const Input = (props) => {
  const inputRef = useRef();
  return (
    <InputDiv
      id={props.id}
      style={
        props.match !== undefined
          ? props.match
            ? { borderStyle: "solid", borderWidth: "2px", borderColor: "green" }
            : { borderStyle: "solid", borderWidth: "2px", borderColor: "red" }
          : { marginTop: "20px" }
      }
    >
      <div>
        <StyledInput ref={inputRef} {...props}></StyledInput>
      </div>
      <div className="image-label">
        <label onClick={() => inputRef.current.focus()} htmlFor={props.id}>
          {props.label}
        </label>
        {props.image && (
          <img onClick={props.show} src={hide} alt="show-password" />
        )}
      </div>
    </InputDiv>
  );
};
export const LeaderBoardIntro = (props) => {
  const [workoutId, setWorkoutId] = useState("");
  const [teamId, setTeamId] = useState("");
  const [title, setTitle] = useState("");
  const [sideTopText, setSideTopText] = useState("");
  const [sideBottomText, setSideBottomText] = useState("");

  const [background, setBackground] = useState("generic-bg");

  const [sideBackground, setSideBackground] = useState("side-bg");

  const [selectWorkoutId, setSelectWorkoutId] = useState(true);

  const [dateFrom, setDateFrom] = useState(undefined);
  return (
    <Container>
      <div className="outer">
        <div>
          <img src={image} alt="logo" width={"130px"}></img>
        </div>
        <h1>Create leaderboard!</h1>
        <div className="max">
          <p></p>
        </div>
        <form>
          <Input
            id="teamId"
            value={teamId}
            type="text"
            onChange={(event) => {
              setTeamId(event.target.value);
            }}
            label="Team id"
          />
          <div className="max">
            <label
              onClick={() => {
                setSelectWorkoutId(true);
                setWorkoutId("dcc398aa-b032-4b3e-863f-5cac043999b2");
              }}
            >
              Select from precreated workouts
            </label>
            <input
              onClick={() => {
                setSelectWorkoutId(true);
                setWorkoutId("dcc398aa-b032-4b3e-863f-5cac043999b2");
              }}
              type={"radio"}
              name="Custom workouts"
              checked={selectWorkoutId}
            />
            <br />
            <label
              onClick={() => {
                setSelectWorkoutId(false);
              }}
            >
              Enter workout id
            </label>

            <input
              onClick={() => {
                setSelectWorkoutId(false);
              }}
              type={"radio"}
              name="Custom workouts"
              checked={!selectWorkoutId}
            />
          </div>
          {selectWorkoutId ? (
            <div className="max">
              <label for="workoutIds">Workout </label>

              <select
                onChange={(event) => {
                  setWorkoutId(event.target.value);
                }}
                name="workoutIds"
                id="workoutIds"
                value={workoutId}
              >
                <option value="dcc398aa-b032-4b3e-863f-5cac043999b2">
                  Folow One
                </option>
                <option value="9f44164c-2a6d-4448-8b5c-c2893051a2a7">
                  Follow Color
                </option>
                <option value="1d596541-4ff6-4a20-af7b-7c8af89fa97e">
                  Follow Sign
                </option>
                <option value="746539a1-0b6b-4290-a39e-c302f88f3224">
                  Follow Sign&Color
                </option>
                <option value="04a689a4-4b08-4ad2-a954-86ed0bb9dd84">
                  Lonely One
                </option>
                <option value="96742d1f-fd7d-4af3-8061-975d00740b93">
                  Advances
                </option>
                <option value="406ae013-e71c-46a3-82db-c0365449c196">
                  Timing gates
                </option>
                <option value="69f2b8e7-2d23-4138-ac20-c2369199fe1a">
                  RAGS
                </option>
              </select>
            </div>
          ) : (
            <Input
              id="teamId"
              value={workoutId}
              type="text"
              onChange={(event) => {
                setWorkoutId(event.target.value);
              }}
              label="Workout id"
            />
          )}

          <div className="max">
            <label for="backgrounds">Background</label>

            <select
              onChange={(event) => {
                setBackground(event.target.value);
              }}
              name="backgrounds"
              id="backgrounds"
            >
              <option value="generic-bg">Generic</option>
              <option value="rimac-background">Rimac</option>
            </select>
          </div>
          <div className="max">
            <label for="side-backgrounds">Side background</label>

            <select
              onChange={(event) => {
                setSideBackground(event.target.value);
              }}
              name="side-backgrounds"
              id="side-backgrounds"
            >
              <option value="side-bg">Generic</option>
              <option value="mrgud">Mrgud</option>
              <option value="nevera">Nevera</option>
            </select>
          </div>

          <Input
            id="title"
            value={title}
            type="text"
            onChange={(event) => {
              setTitle(event.target.value);
            }}
            label="Title"
          />

          <Input
            id="sideTop"
            value={sideTopText}
            type="text"
            onChange={(event) => {
              setSideTopText(event.target.value);
            }}
            label="Side top text"
          />
          <Input
            id="sideBottom"
            value={sideBottomText}
            type="text"
            onChange={(event) => {
              setSideBottomText(event.target.value);
            }}
            label="Side bottom text"
          />

          <div className="max">
            <label htmlFor="start">Start date:</label>

            <input
              type="date"
              id="start"
              name="trip-start"
              value={dateFrom ?? new Date().toISOString().split("T")[0]}
              max={new Date().toISOString()}
              onChange={(e) => {
                setDateFrom(e.target.value);
              }}
            />
          </div>

          <div
            className="max"
            style={{
              borderRadius: "10px",
              backgroundColor: "#FFEB32",
              color: "#313131",
              paddingTop: "10px",
              paddingBottom: "10px",
              justifyContent: "center",
            }}
          >
            <a
              style={{
                color: "#313131",
                padding: "10px",
                alignItems: "center",
                width: "fit-content",
              }}
              href={`/leaderboard?workoutId=${
                workoutId !== ""
                  ? workoutId
                  : "dcc398aa-b032-4b3e-863f-5cac043999b2"
              }&teamId=${teamId}&background=${background}&sideBackground=${sideBackground}&title=${
                title ?? ""
              }&sideTopText=${sideTopText}&sideBottomText=${sideBottomText}${
                dateFrom ? `&from=${dateFrom}` : ""
              }`}
            >
              Create leaderboard
            </a>
          </div>
        </form>
        <div className="max">
          <p>Questions?</p>
          <p>
            Email us at{" "}
            <a href="mailto: info@sportreact.com">info@sportreact.com</a>
          </p>
        </div>
      </div>
    </Container>
  );
};
